import * as React from 'react';
import { FaPizzaSlice, FaTshirt, FaPencilRuler } from 'react-icons/fa'; // Import FaEye for the new button icon
import { TBankerHeader } from '../Components/TBankerHeader'
import  { PapaJohnsFooter}  from './PapaJohnsFooter'; 
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import * as Request from '../tgccRequest';
import  PapaJohnsBannerImage  from './PapaJohnsBannerImage';
import { Dispatch } from 'redux';
import Radium, { StyleRoot } from 'radium';
import {browserHistory} from 'react-router'
import PapaJohnsDropdownMenu from './PapaJohnsDropdownMenu'; // Ensure this path is correct



const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#f2f2f2',
    fontFamily: "'Montserrat', sans-serif",
    padding: '20px',
  },
  form: {
    backgroundColor: '#fff',
    borderRadius: '15px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: '50px',
    maxWidth: '500px',
    width: '100%',
    textAlign: 'center',
  },
  header: {
    fontSize: '2rem',
    color: '#333',
    marginBottom: '10px',
  },
  subHeader: {
    fontSize: '1rem',
    color: '#555',
    marginBottom: '30px',
  },
  input: {
    width: '100%',
    padding: '12px 20px',
    margin: '8px 0',
    borderRadius: '5px',
    border: '1px solid #ccc',
    fontSize: '16px',
    boxSizing: 'border-box',
  },
  inputFocus: {
    borderColor: '#008e6a',
    boxShadow: '0 0 8px rgba(0, 142, 106, 0.2)',
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '20px 0',
    fontSize: '16px',
    cursor: 'pointer',
  },
  submitButton: {
    width: '100%',
    padding: '15px',
    marginBottom: '10px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#008e6a',
    color: '#fff',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    ':hover': {
      backgroundColor: '#007156',
    },
  },
  loginLink: {
    marginTop: '15px',
    fontSize: '14px',
    color: '#008e6a',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  errorMessage: {
    color: 'red', // Change as per your design
    marginBottom: '15px',
  },
  designsPreviewButton: {
    fontSize: '1em',
    padding: '10px 15px',
    backgroundColor: '#ffcc00', // A warm yellow color for the button
    color: '#333', // Dark text for contrast
    border: 'none',
    borderRadius: '25px', // Rounded corners
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
    marginTop: '20px',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    ':hover': {
      transform: 'scale(1.05)',
      boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
    },
  },
  welcomeMessage: {
    textAlign: 'center',
    color: '#333',
    paddingBottom: '30px', // Space below the message
  },
  
  welcomeTitle: {
    fontSize: '2.1rem',
    fontWeight: 'bold',
    marginBottom: '10px', // Space between title and description
  },
  
  welcomeDescription: {
    fontSize: '1rem',
    color: '#555',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  mobileHeader: {
    display: 'flex', // Use flexbox for layout
    justifyContent: 'space-between', // Space between items
    alignItems: 'center', // Align items vertically
    padding: '10px', // Add padding
    // Use a media query for mobile devices
    '@media (max-width: 768px)': {
      flexDirection: 'column', // Stack items vertically on mobile
    },
  },
  mobileMenuButton: {
    alignSelf: 'flex-end', // Align menu to the end
    '@media (max-width: 768px)': {
      order: 2, // Position the menu below the title on mobile
      alignSelf: 'center', // Center menu button on mobile
      marginTop: '10px', // Add space above the menu button on mobile
    },
  },
  topMobileHeaderStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '10px',
    boxSizing: 'border-box',
    backgroundColor: '#f2f2f2', // adjust the color to match your design
  },
  mainContentHeaderStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px',
    width: '100%',
    '@media (max-width: 768px)': {
      padding: '10px 10px 0 10px', // adjust padding for mobile as needed
    },
  },
  
};

interface PapaJohnsRegisterProps {
  state:    Tgcc.GlobalState;
  loginData: Tgcc.LoginData;
  dispatch: Dispatch<any>;
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
  return { 
      state: state,
      loginData: state.LoginData,

  };
};

class _PapaJohnsRegister extends React.Component < PapaJohnsRegisterProps, any > {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      email: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      canReceiveTexts: false,
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      zipCode: '',
      focusedInput: null,
      error: '',
      isMenuOpen: false,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.setState(prevState => ({ isMenuOpen: !prevState.isMenuOpen }));
  }

  
  handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
        [name]: value,
        error: '', // Clear any existing error message
    });
};

  
componentDidMount() {
  this.checkLoginStatus();
}

checkLoginStatus = () => {
  // Assuming loginData is stored in Redux and contains a field indicating the user's login status
  if (this.props.loginData) {
      // User is already logged in, redirect them to the color select page
      browserHistory.push(Tgcc.Routes.PapaJohnsColorSelect);
  }
};

  handleViewDesignsClick = () => {
    browserHistory.push(Tgcc.Routes.ViewPapaJohnsDesigns);
  };

  renderDesignsPreviewLink = () => {
    const { isMenuOpen } = this.state;
    return (
      <div style={{
        display: 'flex', // Use flexbox for horizontal alignment
        justifyContent: 'space-between', // Align items on opposite ends
        alignItems: 'center', // Center items vertically
        padding: '20px', // Add some padding around the items
        backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent white for a lighter feel
        borderBottom: '1px solid #ddd', // A subtle border to separate from the form
        borderTop: '1px solid #ddd', // A subtle border to separate from the banner
      }}>
        {/* Center-aligned items (wrapped in their own div) */}
        <div style={{ flex: 1, textAlign: 'center' }}>
          <p style={{
            color: '#555',
            fontSize: '1rem',
            marginBottom: '10px',
          }}>
            Wanna peek at our curated designs before getting started?
          </p>
          <button
            style={{
              ...styles.designsPreviewButton,
              backgroundColor: '#e9ecef', // A light grey that matches the form
              color: '#333',
              ':hover': {
                backgroundColor: '#dee2e6', // A slightly darker grey on hover
              },
            }}
            onClick={this.handleViewDesignsClick}
          >
            <FaPencilRuler style={{ marginRight: '5px', verticalAlign: 'middle', fontSize: '1.2em' }} />
            View All Papa John's Designs
          </button>
        </div>
        
        {/* Right-aligned items */}
        <div style={{}}>
          <PapaJohnsDropdownMenu 
            isMenuOpen={isMenuOpen} 
            toggleMenu={this.toggleMenu} 
          />
        </div>
      </div>
    );
  };
  
  renderWelcomeMessage = () => {
    return (
      <div style={styles.welcomeMessage}>
        <h2 style={styles.welcomeTitle}>Join the Papa John's Spirit Squad!</h2>
        <p style={styles.welcomeDescription}>
          Register to customize and order your team's spirit wear with ease. Whether you're a slice enthusiast or a topping trendsetter, we're here to ensure you get gear that's as fresh as our pizza. Ready to get started?
        </p>
      </div>
    );
  };
  

  goToNextStep = () => {
    this.setState(prevState => ({ currentStep: prevState.currentStep + 1 }));
  };

  goToPreviousStep = () => {
    this.setState(prevState => ({ currentStep: prevState.currentStep - 1 }));
  };

  renderStepOne = () => {
    const onSubmitStepOne = () => {
      this.handleInitialRegistration();
    };
  
    return (
      <div>
        <form onSubmit={onSubmitStepOne}>
          {this.renderInputField('Email', 'email', 'email')}
          {this.renderInputField('Password', 'password', 'password')}
          {this.renderInputField('Confirm Password', 'password', 'confirmPassword')}
          <button type="submit" style={styles.submitButton} key="submitStepOne">Next</button>
        </form>
      </div>
    );
  };
  
  
  renderStepTwo = () => (
    <div>
        {this.renderInputField('First Name', 'text', 'firstName')}
        {this.renderInputField('Last Name', 'text', 'lastName')}
        {this.renderInputField('Phone Number', 'tel', 'phoneNumber')}
        <label style={styles.checkboxLabel}>
            <input type="checkbox" name="canReceiveTexts" onChange={this.handleChange} /> Can receive texts
        </label>
        <button type="button" style={styles.submitButton} onClick={this.handleDetailsSubmission} key="next2">Next</button>
        <button type="button" style={styles.submitButton} onClick={this.goToPreviousStep} key="back2">Back</button>
    </div>
);

  
  renderStepThree = () => (
    <div>
        {this.renderInputField('Shipping Address Line 1', 'text', 'addressLine1')}
        {this.renderInputField('Shipping Address Line 2 (Optional)', 'text', 'addressLine2')}
        {this.renderInputField('City', 'text', 'city')}
        {this.renderInputField('State', 'text', 'state')}
        {this.renderInputField('ZIP Code', 'text', 'zipCode')}
        <button type="button" style={styles.submitButton} onClick={this.handleAddressSubmission} key="submitAddress">Complete Registration</button>
        <button type="button" style={styles.submitButton} onClick={this.goToPreviousStep} key="back3">Back</button>
    </div>
  );

  

  renderInputField = (placeholder: string, type: string, name: string) => {
    return (
      <input
        style={styles.input}
        type={type}
        name={name}
        placeholder={placeholder}
        onFocus={() => this.setState({ focusedInput: placeholder })}
        onBlur={() => this.setState({ focusedInput: null })}
        onChange={this.handleChange}
        // Ensure you correctly initialize and update these values in state
        value={this.state[name]}
      />
    );
  };

  handleInitialRegistration = (event?: React.FormEvent<HTMLFormElement>) => {
    event?.preventDefault();
    // Initial validations
    const { email, password, confirmPassword } = this.state;
    if (!email || !password || !confirmPassword) {
        this.setState({ error: 'Please fill in all fields.' });
        return;
    }

    if (password !== confirmPassword) {
        this.setState({ error: 'Passwords do not match.' });
        return;
    }

    // Check if the password meets the criteria
    const passwordValidationRegex = /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,}$/;
    if (!passwordValidationRegex.test(password)) {
        this.setState({ error: 'Password must be at least 8 characters long and include an uppercase and lowercase letter, number, and a special character.' });
        return;
    }

    // If all validations pass, check email availability
    this.checkEmailAndProceed();
};

  checkEmailAndProceed = () => {
    const { email } = this.state;
    Request.checkEmailAvailability(email,
      (isInUse) => {
        if (isInUse) {
          this.setState({ error: 'Email is already in use.' });
        } else {
          // Email is available, proceed to the next step
          this.setState({ currentStep: 2, error: '' });
        }
      },
      (error) => {
        console.error('Error checking email:', error);
        this.setState({ error: 'An error occurred while checking the email.' });
      }
    );
  };

  handleDetailsSubmission = () => {
    const { firstName, lastName, phoneNumber } = this.state;

    // Check if the names are not empty (basic validation)
    if (!firstName || !lastName) {
        this.setState({ error: 'Please enter both your first and last name.' });
        return;
    }

    // Phone number validation regex
    const phoneNumberValidationRegex = /^(?:\+1)?(?:\((\d{3})\)|(\d{3}))[-. ]?(\d{3})[-. ]?(\d{4})$/;

    // Validate phone number format
    if (!phoneNumberValidationRegex.test(phoneNumber)) {
        this.setState({ error: 'Please enter a valid phone number.' });
        return;
    }

    // If all validations pass, proceed to the next step
    this.goToNextStep();
};

handleAddressSubmission = () => {
  const { addressLine1, city, state, zipCode } = this.state;

  // Basic validation to ensure address fields are not empty
  if (!addressLine1.trim() || !city.trim() || !state.trim() || !zipCode.trim()) {
      this.setState({ error: 'Please fill in all address fields.' });
      return;
  }

  // ZIP code validation regex for US ZIP code (5 digits or ZIP+4 format)
  const zipCodeValidationRegex = /^(\d{5}(-\d{4})?)$/;

  if (!zipCodeValidationRegex.test(zipCode)) {
      this.setState({ error: 'Please enter a valid ZIP code.' });
      return;
  }

  // If all validations pass, proceed with registration finalization
  this.handleFinalRegistration();
};


handleFinalRegistration = () => {
  // Initialize a new UserInfo instance
  var user = new Tgcc.UserInfo();
  
  user.email = this.state.email;
  user.firstName = this.state.firstName;
  user.lastName = this.state.lastName;
  user.phone = this.state.phoneNumber;
  user.smsAllowed = this.state.canReceiveTexts;
  user.address = this.state.addressLine1;
  user.address2 = this.state.addressLine2;
  user.city = this.state.city;
  user.state = this.state.state;
  user.zip = this.state.zipCode;
  user.schoolOrBusiness = `Papa Johns - ${this.state.city}`

  Request.registerUser(user, this.state.password, this.state.confirmPassword,
    (response) => {
      // On successful registration, attempt to log the user in
      Request.loginUser(this.state.email, 
        this.state.password, 
        (ld: Tgcc.LoginData)=>{ Tgcc.successfulLogin(this.props.dispatch, ld)
          
          // After successful login, redirect to the color-select page
          // Adjust navigation based on your project's routing setup
          browserHistory.push(Tgcc.Routes.PapaJohnsColorSelect);
        
        },
        this.failedLogin // Handle login failure after successful registration
      );
    },
    (error) => {
      // Handle registration error
      console.error("Registration failed", error);
      this.setState({ error: "Registration failed. Please try again." });
    }
  );
};

failedLogin = (err: any) => {
  this.setState({error: "registration succeeded, but login failed", isWaiting: false});
}


render() {
  const { isMenuOpen } = this.state;
  const { currentStep, error } = this.state;
  const { state } = this.props;

  return (
    <div>
      < PapaJohnsBannerImage />
      {this.renderDesignsPreviewLink()}
      <div className="pj-register-container" style={styles.container}>
        <form onSubmit={e => e.preventDefault()} style={styles.form}>
          {this.renderWelcomeMessage()}
          {/* <div style={styles.header}>Register or Login to The Graphic Cow Co.</div>
          <div style={styles.subHeader}>Register or login for quick and easy custom Papa John's apparel.</div> */}
          {/* Conditionally render error message */}
          {error && <div style={styles.errorMessage}>{error}</div>}
          {currentStep === 1 && this.renderStepOne()}
          {currentStep === 2 && this.renderStepTwo()}
          {currentStep === 3 && this.renderStepThree()}
          {currentStep === 1 && <div style={styles.loginLink}><a href={`/login?returnUrl=${encodeURIComponent(Tgcc.Routes.PapaJohnsColorSelect)}`} style={{ textDecoration: 'none', color: styles.loginLink.color }}>Already have an account? Login</a></div>}
        </form>
      </div>
      <PapaJohnsFooter/>
    </div>
  );
}

}



export var PapaJohnsRegister = connect(mapStateToProps)(Radium(_PapaJohnsRegister));